import { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Models
import { IConversation } from 'app/models/ChatAI';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { getConversations } from 'app/store/AIChat/AIChat.async';
// Selectors
import { selectCaseAiChatEnabled } from 'app/store/Cases/Cases.selectors';
import { selectConversations } from 'app/store/AIChat/AIChat.selectors';
// Mui
import { List, ListSubheader } from '@mui/material';
// Components
import { Loader, Message } from 'app/components/Utilities';
// 
import ChatListItem from './ChatListItem';

export default function ChatListItems() {
  const { t } = useTranslation();
  const { caseId } = useParams<{ caseId:string; }>()

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const caseAiChatEnabled = useAppSelector(selectCaseAiChatEnabled);
  const conversations:IConversation[] | null = useAppSelector(selectConversations);

  useEffect(() => {
    dispatch(getConversations({ caseId: Number(caseId) }));
    // eslint-disable-next-line
  }, []);

  if ( !caseAiChatEnabled ) return null;
  if ( !conversations ) return <Loader />;
  if ( !conversations.length ) return <Message text={t('pages.aiChat.noConversationsData')} />;
  return (
    <List sx={{ overflowY: 'auto', pt: 0 }}>
      <ListSubheader>Chats</ListSubheader>
      {conversations.map((conversation:IConversation) => (
        <ChatListItem
          key={`conversation item ${conversation.id}`}
          conversation={conversation}
        />
      ))}
    </List>
  )
};
